import { ActionTypes } from 'src/types/types';

export const FEATURE_NAME = 'widgets';
export const actionTypes = {
  FETCH_WIDGET_DATA: `${FEATURE_NAME}/FETCH_WIDGET_DATA`
} satisfies ActionTypes<typeof FEATURE_NAME>;
    